import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-document',
  templateUrl: './modify-document.component.html',
  styleUrls: ['./modify-document.component.css']
})
export class ModifyDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
